import React from 'react';

export default ({ status }) => {
  switch (status) {
    case 'REGISTERED':
      return <span className="badge badge-secondary">Registered</span>;
    case 'IN_PROGRESS':
      return <span className="badge badge-warning">In progress</span>;
    case 'FINISHED':
      return <span className="badge badge-success">Finished</span>;
    default:
      return <span className="badge">Unknown status {status}</span>;
  }
};



// WEBPACK FOOTER //
// ./src/components/results/StatusBadge.js